import {spacing} from "@khanacademy/wonder-blocks-tokens";

export const CONTROLS_HEIGHT = spacing.xxxLarge_64 + 14;
export const CARD_OFFSET = spacing.xSmall_8;

export const CARD_HEIGHT = 450;
export const CARD_WIDTH = 370;

// When the number of cards in below this threshold, we request more
export const REFILL_THRESHOLD = 10;

// This is the default time limit for each Blooket question
export const DEFAULT_TIME_LIMIT = 80;

// These character limits are enforced by the Blooket export API.
export const TITLE_CHARACTER_LIMIT = 75;
export const DESCRIPTION_CHARACTER_LIMIT = 300;
export const QUESTION_ANSWER_CHARACTER_LIMIT = 300;

// Used for animations in both Deck and QuestionSet
export const ANIMATION_DURATION = 800;
